import { useState } from 'react';
import { useDrawer } from '../../../shared/drawer';
import { Table } from "../../../elements/table";
import { PageBody } from '../../../elements/page-body';
import { MarcasForm } from './marcas-form';




export const MarcasPage = () => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);


    const handleNewAction = () => {
        open('common.form-title.new', <MarcasForm close={handleClose} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };



    return (
        <PageBody
            title={'common.label.marcas'}
            newAction={handleNewAction}
            newActionTitle={'common.form-title.new'}
        >

            <>

                <Table
                    path="/fleet/car-brands/"
                    deletePath="/fleet/car-brands/"
                    callBeforeDrawerClosed={handleClose}
                    Form={MarcasForm}
                    withPagination
                    refresh={refresh}
                    headers={[
                        {
                            key: 'name',
                            label: 'common.label.marca',
                        }/* , {
                        key: 'description',
                        label: 'common.form-label.description',
                    } */
                    ]}
                />
            </>
        </PageBody>
    );
};